function getContentHeight(content) {
  const innerContent = content.querySelectorAll("*");
  const innerContentArray = Array.from(innerContent);
  return innerContentArray
    .filter((item) => item.nodeType === 1)
    .reduce((acc, cur) => acc + cur.clientHeight, 0);
}

document.addEventListener("DOMContentLoaded", function () {
  const splitImages = document.querySelectorAll(".split-image");
  splitImages.forEach(function (splitImage) {
    const content = splitImage.querySelector(".wp-block-column:nth-child(2)");
    const image = splitImage.querySelector(".wp-block-image img");
    if (!content || !image) return;
    image.style.maxHeight = `calc(${getContentHeight(content)}px + 4rem)`;
    window.addEventListener("resize", () => {
      image.style.maxHeight = `calc(${getContentHeight(content)}px + 4rem)`;
    });
  });
});
